export const FILE_TYPES = {
    IMAGE: ['image/*'],
    PDF: ['application/pdf'],
    CSV: ['text/csv', '.csv'],
    VIDEO: ['video/*']
}